export default __webpack_public_path__ + "static/media/wordpress.4017c17c.svg";